import { render } from "./RecapSlider.vue?vue&type=template&id=237e0252&scoped=true"
import script from "./RecapSlider.vue?vue&type=script&lang=js"
export * from "./RecapSlider.vue?vue&type=script&lang=js"

import "./RecapSlider.vue?vue&type=style&index=0&id=237e0252&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237e0252"]])

export default __exports__